const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "::1"]);

export const isLocalOnboardingPreviewEnabled = ({
  nodeEnv = process.env.NODE_ENV,
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  search = typeof window !== "undefined" ? window.location.search : "",
} = {}) => {
  const normalizedHostname = String(hostname).trim().toLowerCase().replace(/^\[|\]$/g, "");

  return nodeEnv === "development"
    && LOOPBACK_HOSTS.has(normalizedHostname)
    && new URLSearchParams(search).get("onboardingPreview") === "1";
};
